import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CommonService, SharedserviceService } from 'src/app/services';

declare var $: any;

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.scss']
})
export class EnquiryComponent implements OnInit {
  bodydata: any = {};
  enquiryFormGroup: FormGroup;
  submitted: boolean = false;
  public page: number = 1;
  btndisabled: boolean=false;
  userdata:any;
  userAgency:any;
  sent_data:any;
  TotalCount:any;
  seenData:any;
  keys:any;
  constructor(public sharedService: SharedserviceService,
    private fb: FormBuilder,
    public router: Router,
    private toastr: ToastrManager,
    public activatedRoute: ActivatedRoute) {
      this.userAgency = JSON.parse(localStorage.getItem('userAgency_diamond'));
      this.userdata=JSON.parse(localStorage.getItem("user"));
  }

  get f() { return this.enquiryFormGroup.controls; }

  ngOnInit() {
    this.enquiryShowList();
    this.enquiryFormGroup = this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      company_name: ['', Validators.required],
      subject: ['',Validators.required],
      message: ['',Validators.required]
    });

    // this.bodydata = {
    //   "email": this.enquiryFormGroup.value.email,
    //   "mobile": this.enquiryFormGroup.value.mobile,
    //   "name": this.enquiryFormGroup.value.name,
    //   "company_name": this.enquiryFormGroup.value.company_name,
    //   "subject": this.enquiryFormGroup.value.subject,
    //   "message": this.enquiryFormGroup.value.message
    // }
  }

   enqSeenData(element) {
    var myData = element;
    console.log("check my enquiry data:::::::::", myData);
  
          sessionStorage.setItem("seenData",JSON.stringify(myData));
          this.router.navigate(['/enquiry-seen']);
  }

  enquiryShowList() {
    var request = {
      "page_limit": 10,
      "page_no": 1
    }
    // if (type == 'sent') {
      this.sharedService.post('v1/enquiry/list', request).subscribe((res: any) => {
        if (res.replyCode == "success") {
          this.sent_data = res.data;
          this.TotalCount = res.count;
          this.keys = Object.keys(this.sent_data[0]);
        }
      }, err => {
        this.toastr.errorToastr(err.replyMsg)
      })
  }


  onPageChange(event) {
    this.bodydata['page'] = event;
    this.bodydata['page_no'] = event;
  }



  reverseAndTimeStamp(dateString) {
    const reverse = new Date(dateString.split("-").reverse().join("-"));
    return reverse.getTime();
  }

  get fs() { return this.enquiryFormGroup.controls; }

  addEnquiry(){
    this.submitted = true;
    if (this.enquiryFormGroup.invalid) { 
      return;
    }else{
      const self=this;
      self.sharedService.loadingShow = true; 
      var requestData ={
        "name":this.enquiryFormGroup.value.name,
        "email":this.enquiryFormGroup.value.email,
        "subject": this.enquiryFormGroup.value.subject,
        "message": this.enquiryFormGroup.value.message,
        "company_name": this.enquiryFormGroup.value.company_name,
        "mobile": Number(this.enquiryFormGroup.value.mobile),
        "send_to_email":"sunil.fareboutique@gmail.com"
      }

      console.log("form body data list:::::::::",requestData);
      // return;
      
        this.sharedService.postRequest('v1/enquiry/add',requestData).subscribe((res)=> {
          if(res.replyCode == 'success'){
            this.submitted = false;
            $('#sentmodal').modal('hide');
            this.enquiryFormGroup.reset();
            this.enquiryShowList()
            this.toastr.successToastr(res.replyMsg, 'Success');
          }else{
            this.submitted = false
            $('#sentmodal').modal('hide');
            this.toastr.errorToastr(res.replyMsg, 'Error');
          }
        },err=>{
          if(err.error.replyMsg.message){
            this.submitted = false
            this.toastr.errorToastr(err.error.replyMsg.message, 'Error');
            $('#sentmodal').modal('hide');
            this.enquiryFormGroup.reset();
          }else{
            this.submitted = false
            $('#sentmodal').modal('hide');
            this.toastr.errorToastr(err.error.replyMsg, 'Error');
          }
        });
      }
  }



}

